import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createItemFromListing } from '../lib/create-item';
import { catalogMappingKeys } from '../lib/query-keys';
import type { CreateItemBody } from '../lib/types';

export type CreateItemVariables = {
  listingId: string;
  body: CreateItemBody;
};

/*
 * Creates a catalog item from an unmapped listing and maps the listing to it,
 * so it refreshes every mapping tab and the unmapped count, whatever the answer.
 */
export function useCreateItemFromListing() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ listingId, body }: CreateItemVariables) =>
      createItemFromListing(listingId, body),
    // Settled, not success: a refused create (ALREADY_MAPPED) says the lists are stale.
    onSettled: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: catalogMappingKeys.mappableLists(),
        }),
        queryClient.invalidateQueries({
          queryKey: catalogMappingKeys.duplicateLists(),
        }),
        queryClient.invalidateQueries({
          queryKey: catalogMappingKeys.conflictLists(),
        }),
        // The new item belongs in the item picker too.
        queryClient.invalidateQueries({
          queryKey: [...catalogMappingKeys.all, 'mapping-items'],
        }),
      ]),
  });
}
